// fueling invoices (Accounting) — a log of fuel added to vessels for internal cost tracking.
// one row per fueling event; a vessel can have many. worker validates, SPA reuses.
import { z } from 'zod';
export const FuelingInputSchema = z
    .object({
    id: z.number().int().positive().optional(),
    sap: z.string().max(50).optional().default(''),
    model: z.string().max(80).optional().default(''),
    vesselName: z.string().max(160).optional().default(''),
    litres: z.number().min(0).max(1_000_000).nullable().optional(),
    cost: z.number().min(0).max(100_000_000).nullable().optional(),
    supplier: z.string().max(160).optional().default(''), // supplier / invoice reference
    fueledOn: z.string().max(20).optional().default(''), // YYYY-MM-DD
    notes: z.string().max(1000).optional().default(''),
})
    .refine((o) => !!(o.sap.trim() || o.vesselName.trim()), { message: 'A SAP or vessel name is required', path: ['vesselName'] });
export const FuelingIdSchema = z.object({ id: z.number().int().positive() });
//# sourceMappingURL=fueling.js.map